export const defaultPageSize = 19;
export const defaultRowHeight = 48;
